import ActionType from 'actions/ActionType'

export default (state = { displayed: false, index: 1 }, action) => {
  switch (action.type) {
    case ActionType.Campaign.CLICK_BOTTOM_NAVIGATION:
      return { ...state, index: action.payload }
    case ActionType.Campaign.TOGGLE_BOTTOM_NAV:
      return {
        ...state,
        displayed: action.payload ? action.payload : !state.displayed,
      }
    default:
      return state
  }
}
